<template>
    <div class="map-view grid-x grid-margin-x">
        <form @submit.prevent="lookupAddress" class="small-12 cell">
            <input type="text" v-model="address" placeholder="Enter your address">
            <button type="submit">Submit</button>
        </form>

        <div class="map-canvas small-12 medium-8 cell"></div>
        <div class="info small-12 medium-4 cell" v-if="info !== null">
            <h3>District {{ info.get('DISTRICT_N') }}</h3>
            <p>Council Member</p>
            <h4><a :href="info.get('URL')">{{ info.get('name') }}</a></h4>
            <div class="contact">
                <div class="phone">{{ info.get('PHONE') }}</div>
                <div class="email"><a :href="`mailto:${info.get('EMAIL')}`">{{ info.get('EMAIL') }}</a></div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import { loaded } from './loader'

var map;
var kml;
var markerLayer;
var marker;
var styleCache = {};
export default {
    name: 'map-view',
    data () {
        return {
            address: '',
            info: null,
        }
    },
    methods: {
        async lookupAddress () {
            let key = 'AIzaSyCpMeskRlvQK8iPOY1J2kwphwmlTBVYawE'
            if (this.address) {
                if (!/(Wilmington|Delaware|19801|19802|19805|19806)/ig.test(this.address)) {
                    this.address = this.address + " Wilmington Delaware"
                }

                let resp = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?key=${key}&address=${this.address}`);

                if (resp.data.results.length > 0) {

                    let point = resp.data.results[0].geometry.location;
                    let coord = ol.proj.fromLonLat([point.lng, point.lat])
                    marker.setGeometry(new ol.geom.Point(coord))

                    let features = kml.getSource().getFeaturesAtCoordinate(coord)

                    map.getView().setZoom(14)
                    map.getView().setCenter(coord)

                    if (features.length > 0) {
                        this.info = features[0];
                    }
                    else {
                        this.info = null;
                    }

                }
                else {
                    this.info = null;
                }

                let params = new URLSearchParams({'q': this.address})
                history.replaceState({}, document.title, '?' + params.toString())
            }
        },
        gotoDistrict (district) {
            let src = kml.getSource()
            src.once('change', (event) => {
                if (src.getState() == 'ready') {
                    src.forEachFeature((ft) => {
                        let num = ft.get('DISTRICT_N');
                        if (district == num) {
                            let ext = ft.getGeometry().getExtent()
                            let center = ol.extent.getCenter(ext)
                            let coord = ol.proj.toLonLat(center)
                            console.log(coord)
                            map.getView().setZoom(14)
                            map.getView().setCenter(center)
                            this.info = ft
                            return true
                        }
                    });
                }
            });
        },
        styleFunction (feature) {
            // let name = feature.get('name');
            let district = feature.get('DISTRICT_N');
            // let stroke = new ol.style.Stroke({color: 'rgba(220, 75, 62, 1.0)', width: 2})
            // let fill = new ol.style.Fill({color: 'rgba(244, 224, 174, 0.25)'})
            let stroke = new ol.style.Stroke({color: 'rgba(0, 79, 159, 1.0)', width: 2})
            let fill = new ol.style.Fill({color: 'rgba(0, 120, 200, 0.05)'})
            let style = styleCache[district];

            if (!style) {
                style = new ol.style.Style({
                    geometry: 'geometry',
                    stroke: stroke,
                    fill: fill,
                    text: new ol.style.Text({
                        font: 'bold 24px sans-serif',
                        textAlign: 'center',
                        text: district,
                        stroke: new ol.style.Stroke({color: 'white', width: 3}),
                    }),

                });
                styleCache[district] = style;
            }

            return style;
        },

      async loadMap() {
        let _ = await loaded

        kml = new ol.layer.Vector({
          source: new ol.source.Vector({
            url: '/map/council.kml',
            format: new ol.format.KML({
              extractStyles: false,
            })
          }),
          style: this.styleFunction,
        })

        marker = new ol.Feature({
          geometry: null,
        })

        var iconStyle = new ol.style.Style({
          image: new ol.style.Icon({
            anchor: [0.5, 1.0],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: '/map/map-pin.svg'
          })
        })
        marker.setStyle(iconStyle)
        markerLayer = new ol.layer.Vector({
          source: new ol.source.Vector({
            features: [marker]
          }),
        })


        map = new ol.Map({
          target: this.$el.querySelector('.map-canvas'),
          layers: [
            // new ol.layer.Tile({
              // source: new ol.source.BingMaps({
              //   key: 'AlOh7pCrLnhuq-pSMjz22KmaH5dKC4U6pUHqRENrzSwwr1f0qnVRaPEXwpm2IKWa',
              //   imagerySet: 'road',
              // })
            // }),
            new ol.layer.Tile({
              source: new ol.source.OSM()
            }),
            kml,
            markerLayer,
          ],
          view: new ol.View({
            center: ol.proj.fromLonLat([-75.529805, 39.750591]),
            // zoom: 8.342423706113604,
            minZoom: 2,
            maxZoom: 18,
            zoom: 12
          })
        });

        console.log(map)

        //map.on('click', function(evt) {
        //    var feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        //        return feature;
        //    });
        //});

        map.once('postrender', async (evt) => {
          if (location.search) {
            let params = new URLSearchParams(location.search)
            if (params.has('q')) {
              this.address = params.get('q')
              await this.lookupAddress()
            }
            else if (params.has('district')) {
              this.gotoDistrict(params.get('district'))
            }
          }
        })
      },
    },
    mounted () {
      this.loadMap()
    },
}
</script>



// WEBPACK FOOTER //
// MapView.vue?6fa6e1d4